// Utility layer (TS-2.5.04). RoadmapFilterOptions.statuses carries a reference CODE
// ("on-track") beside the canonical LABEL ("On Track") a caller round-trips as
// RoadmapFilterParams.statuses (decisions.md D-199). BoardChip.statusCanonical carries only the
// label. The status axis is "MultiSelectAdditive" with "Dim" as its board effect
// (RoadmapFilterSemantics.statusEffectOnBoard) - the server therefore does NOT remove a chip
// whose status was not selected (only GlanceGroup cards narrow server-side, via "Hide"), so this
// module is what lets the client tell which already-returned chips to visually de-emphasize.
import type { FilterChoice } from "../../../api/generated/contracts";

/** Maps each selected status CODE to the canonical LABEL a BoardChip carries. */
export function resolveSelectedStatusLabels(selectedCodes: readonly string[], statuses: readonly FilterChoice[]): ReadonlySet<string> {
  const labelByCode = new Map(statuses.map((choice) => [choice.code, choice.label]));
  const labels = selectedCodes.map((code) => labelByCode.get(code)).filter((label): label is string => label !== undefined);
  return new Set(labels);
}

/**
 * A chip is dimmed when at least one status is selected and this chip's status is not among
 * them - matching the recovered reference's `opacity .18` rule (decomposition.md section 8.7
 * point 9), applied only when the caller has actually narrowed the status axis.
 */
export function isChipDimmed(statusCanonical: string, selectedLabels: ReadonlySet<string>): boolean {
  return selectedLabels.size > 0 && !selectedLabels.has(statusCanonical);
}
